import useBucketsStore, {
  IBucket,
} from "../../../views/Orders/store/useBucketsStore";
import { SelectedSupplier, PartQuantity } from "./partsCalculationUtils";

export const useBucketMethods = () => {
  const buckets = useBucketsStore((s) => s.buckets);
  const deleteBucket = useBucketsStore((s) => s.deleteBucket);
  const saveBucket = useBucketsStore((s) => s.saveBucket);
  const cleanupStaleBuckets = useBucketsStore((s) => s.cleanupStaleBuckets);

  return {
    getBucketsByOrderNumber: (orderNumber: string): IBucket[] =>
      buckets[orderNumber] || [],

    getBucketCountByOrderNumber: (orderNumber: string): number =>
      (buckets[orderNumber] || []).length,

    deleteBucketByBucketId: (orderNumber: string, bucketId: string) =>
      deleteBucket(orderNumber, bucketId),

    saveCurrentSelectionAsBucket: (
      orderNumber: string,
      suppliers: SelectedSupplier[],
      originalParts: PartQuantity[]
    ) => saveBucket(orderNumber, suppliers, originalParts),

    cleanupStaleSupplierDiscoveryBucketsForToday: () => cleanupStaleBuckets(),
  };
};
